// 账户首页
import request from '@/utils/request'

// 修改密码（登录后）
export function fetchResetPasswordAfterLogin(data) {
  return request({
    url: '/market/login/resetPassword',
    method: 'put',
    data,
  })
}

// 用户详细信息
export function fetchGetUserInfo() {
  return request({
    url: '/market/info/baseInfo',
    method: 'get',
  })
}

// 待审核&被挂起佣金
export function fetchGetFraudsBonusAndPendingBonus() {
  return request({
    url: '/market/info/bonus',
    method: 'get',
  })
}

// 首页趋势表
export function fetchGetTrendingChart(data) {
  return request({
    url: '/market/report/trendChart',
    method: 'get',
    params: data,
  })
}

// 首页国家表
export function fetchGetTop5Countries(data) {
  return request({
    url: '/market/statistics/topcountryReport',
    method: 'get',
    params: data,
  })
}

// 首页出金
export function fetchWithdraw(data) {
  return request({
    url: '/market/keywords/passed',
    method: 'post',
    data,
  })
}
